import layoutState from "./layoutState"
import emptyLayoutState from "./emptyLayoutState"
import cxUserPortraitsState from "./cxUserPortraitsState"
import cxPageLayout from "./cxPageLayout"
import cxPageLayoutOld from "./cxPageLayoutOld"
import cxLoginState from "./cxLoginState"
import cxGraphicState from "./cxGraphicState"
import cxSystemTextState from "./cxSystemTextState"
import cxSystemNavState from "./cxSystemNavState.js"
import cxSystemSearchState from "./cxSystemSearchState.js"
import cxSystemLoginState from "./cxSystemLoginState.js"
import cxSimpleSearchState from "./cxSimpleSearchState"
import cxSystemAccordionState from "./cxSystemAccordionState"
import { materialLoader } from "core/materialLoader"
import cxBayWindow from "./cxBayWindow"
import cxPageLayoutComponent from "./cxPageLayoutComponentState"
import cxHeader from "./cxHeader"
import cxFooter from "./cxFooter"

export const pageLayout = {
  cxPageLayout
}
export const pageLayoutOld = {
  cxPageLayoutOld
}
export const pageLayoutComponent = {
  cxPageLayoutComponent
}
export const baseState = {
  ...materialLoader.getMenusByStageAndGroup("app", "baseElement")
}

export const allState = {
  cxGraphicState,
  cxSystemTextState,
  cxSystemSearchState,
  cxSimpleSearchState,
  ...materialLoader.getMenusByStageAndGroup("app", "element")
}

export const highLevelState = {
  cxUserPortraitsState,
  cxSystemNavState,
  cxSystemLoginState,
  cxLoginState,
  // emptyLayoutState,
  cxSystemAccordionState,
  ...materialLoader.getMenusByStageAndGroup("app", "highLevel")
}

export const bigScreenState = {
  ...materialLoader.getMenusByStageAndGroup("app", "chart")
}

export const collect = {
  layoutState,
  emptyLayoutState
}

export const global = {
  cxHeader,
  cxFooter,
  cxBayWindow
}
